import Invoice from "./invoice/invoice";

const InvoiceReceipt = () => {
    return ( <>
        <Invoice />
    </>
    )
}

export default InvoiceReceipt;